import { trackEvent } from 'tracking/tracking';
import { MigrationId } from './types';

export const trackPresentationLinkClicked = (activeMigrationId: MigrationId) =>
  trackEvent('Clicked presentation link in view migration checklist', {
    activeView: activeMigrationId,
  });

export const trackOpenedMigrationChecklist = () =>
  trackEvent('Opened view migration checklist');

export const trackClickedMigrationChecklistTab = (
  clickedViewTab: MigrationId
) =>
  trackEvent('Clicked view tab in view migration checklist', {
    clickedViewTab,
  });

export const trackClickedKBArticleLink = (activeMigrationId: MigrationId) =>
  trackEvent('Clicked view migration knowledge base link', {
    activeView: activeMigrationId,
  });
